var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM16.23 18L12 15.45L7.77 18L8.89 13.19L5.16 9.96L10.08 9.54L12 5L13.92 9.53L18.84 9.95L15.11 13.18L16.23 18Z"}));
}

StarInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"black"};

module.exports = StarInline;

StarInline.default = StarInline;
